import React from 'react';
import { Box, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { tokens } from '../../theme/tokens';
import { useAppTranslation } from '../../i18n/useAppTranslation';
import { isLensFocalCategoryKey } from '../../constants/lensFocalCategoryKeys';

interface Props {
  slug: string;
  monoSx: SxProps<Theme>;
  /** Flag `lens_focal_range`: say under a lens focal-range row what it matches. */
  lensFocalRange?: boolean;
}

/** A category-map row's slug, with a one-line hint under the lens focal-range rows (MOT-452). */
const CategorySlugLabel: React.FC<Props> = ({ slug, monoSx, lensFocalRange = false }) => {
  const { t } = useAppTranslation();
  const label = (
    <Typography sx={[{ color: tokens.ink.primary }, ...(Array.isArray(monoSx) ? monoSx : [monoSx])]} noWrap title={slug}>
      {slug}
    </Typography>
  );
  if (!lensFocalRange || !isLensFocalCategoryKey(slug)) return label;
  return (
    <Box sx={{ minWidth: 0 }}>
      {label}
      <Typography variant="caption" sx={{ display: 'block', color: tokens.ink.muted }}>
        {t('lensFocalRange.mapRowHint')}
      </Typography>
    </Box>
  );
};

export default CategorySlugLabel;
